// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
    display: flex;
    align-items: center;
    background-color: #fbfbfb;
    padding: 5px;
    justify-content: space-between;
  }
  
  .icon {
    margin-right: 10px;
  }
  .iconprofils {
    margin-left: auto;
  }
  
  .title h1 {
    margin: 0;
    color: #444746;
    font-family: Google Sans,Roboto,RobotoDraft,Helvetica,Arial,sans-serif;
    font-size: 17px;
    text-align: left;
    font-variant-ligatures: no-contextual;
    font-weight: normal;
    padding-bottom: 2px;
    font-weight: 500;
    text-shadow: 0 0 black;
  }
  
  .title p {
    margin: 0;
    font-family: Google Sans,Roboto,RobotoDraft,Helvetica,Arial,sans-serif;
    font-size: 14px;
    color: #444746;
    overflow: hidden;
    vertical-align: text-bottom;
  }
  

  nav ul {
    font-family: Google Sans,Roboto,RobotoDraft,Helvetica,Arial,sans-serif;
    font-size: 14px;
    list-style: none;
    padding: 0;
    margin: 0;
    margin-left: -6px;
  }
  
  nav ul li {
    display: inline-block;
    position: relative;
  }
  
  nav ul li a {
    vertical-align: text-bottom;
    display: block;
    padding: 0px 6px;
    text-decoration: none;
    color: #333;

  }
  
  nav ul li:hover > ul {
    display: block;
  }
  
  nav ul ul {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    background-color: #ffffff;
    padding: 0;
    width: auto;
    margin-left: 5px;
    z-index:99999;
  }
  
  nav ul ul li {
    width: 100%;
    min-width: 150px;
  }
  
  nav ul ul li a {
    padding: 10px 20px;
    font-size: 12.5px;
  }
  
  nav ul ul li a:hover {
    background-color: rgb(220, 220, 220);
    width: auto;
  }

  nav ul ul ul {
    top: 0;
    left: 100%;
  }
   
  .box {
    width: auto; /* 100% of the viewport width */
    height: auto; /* 100% of the viewport height */
    background-color: #ffffff;
    overflow: auto;
    border: 1px solid #e6e3e3;
  }
  
  .box_icon {
    width: 97.50vw;
    height: 39px;
    background-color: #eff6ff;
    margin: 10px;
    border-radius: 50px;
    padding: 2px 2px 2px 6px;
  }
  
  .icon_option_select {
    display: inline-block;
    vertical-align: middle;
  }
  .icon_option {
    display: inline-block;
    margin: 5px;
  }
  
  .icon_option img {
    width: 24px; /* Adjust the width as needed */
    height: 24px; /* Adjust the height as needed */
  }

.material-symbols-outlined {
    padding: 1px;
    color: #444746;
  font-variation-settings:
  'FILL' 0,
  'wght' 200,
  'GRAD' 0,
  'opsz' 24
}
.material-symbols-outlined:hover{
    cursor: pointer;
    background-color: rgb(226, 226, 226);
    border-radius: 5px;
    padding: 1px;
}
.container-main-view {
  background: #f9fbfd !important;
  border-bottom: 1px solid #f9fbfd !important;
  margin-bottom: -1px !important;
  padding: 10px !important;
  box-shadow: 0 2px 4px rgba(166, 166, 166, 0.1); /* Add box shadow */
}
.submenu-items i {
    color: #444746;
    margin-right: 10px;
}
.flex-box{
    width: 100% !important;
}
.positionfix{
    position:fixed;
    bottom:0px;
    right:0px;
    z-index:9999;
    width: 100%;
    background-color: #F0F0F0;
}
.positionfixduplicatetable{
    position: fixed;
    bottom: 0px;
    right: 0px;
    z-index: 9999;
    width: 100%;
    background-color: #eff6ff;
    height: 300;
    overflow: auto;
    border-top: 2px solid #ccc;
}
.select2-dropdown{
  z-index: 99999 !important;
}

/* Styles for the menu */
.menu {
  display: flex;
  justify-content: space-between;
  color: #444746;
  font-size: 14px;
  letter-spacing: .2px;
  text-shadow: 0 0 black;
}

/* Styles for each menu category */
.menu div {
  margin-right: 20px;
}

.menu h2 {
  font-size: 16px;
  margin-bottom: 5px;
}

.menu ul {
  list-style: none;
  padding: 0;
}

/* Styles for each menu item */
.menu li {
  /* margin-bottom: 5px; */
}

.menu li a {
  color: #333;
  text-decoration: none;
  display: flex;
  align-items: center;
  font-size: 14px;
}

.menu li a i {
  margin-right: 10px;
}

.luckysheet-cell-row-0 {
  font-weight: bold;
}


/* .btn, .btn-large, .btn-small, .btn-flat  {
  line-height: 6px !important;
  display: inline-block;
  height: 18px !important;
  padding: 0 2rem;
  vertical-align: middle;
  text-transform: uppercase;
  border: none;
  border-radius: 2px;
  -webkit-tap-highlight-color: transparent;
}

input:not([type]), input[type=text]:not(.browser-default), input[type=password]:not(.browser-default), input[type=email]:not(.browser-default), input[type=url]:not(.browser-default), input[type=time]:not(.browser-default), input[type=date]:not(.browser-default), input[type=datetime]:not(.browser-default), input[type=datetime-local]:not(.browser-default), input[type=tel]:not(.browser-default), input[type=number]:not(.browser-default), input[type=search]:not(.browser-default), textarea.materialize-textarea {
  font-size: 1rem  !important;
  margin: 0 0 8px 0  !important;
  margin-left: 9px  !important;
  margin-right: 9px  !important;
  padding: 0;
  transition: box-shadow .3s, border .3s;
  border: 1px solid #615c5c  !important;
  border-radius: 5px  !important;
  height: 2rem !important;
  text-align: center;
} */


.form-inline {
	display: inline-block;
}
.navbar-header.col {
	padding: 0 !important;
}
.navbar {		
	background: #fff;
	padding-left: 16px;
	padding-right: 16px;
	border-bottom: 1px solid #d6d6d6;
	box-shadow: 0 0 4px rgba(0,0,0,.1);
}
.nav-link img {
	border-radius: 50%;
	width: 36px;
	height: 36px;
	margin: -8px 0;
	float: left;
	margin-right: 10px;
}
.navbar .navbar-brand {
	color: #555;
	padding-left: 0;
	padding-right: 50px;
	font-family: 'Merienda One', sans-serif;
}
.navbar .navbar-brand i {
	font-size: 20px;
	margin-right: 5px;
}
.search-box {
	position: relative;
}	
.search-box input {
	box-shadow: none;
	padding-right: 35px;
	border-radius: 3px !important;
}
.search-box .input-group-addon {
	min-width: 35px;
	border: none;
	background: transparent;
	position: absolute;
	right: 0;
	z-index: 9;
	padding: 7px;
	height: 100%;
}
.search-box i {
	color: #a0a5b1;
	font-size: 19px;
}
.navbar .nav-item i {
	font-size: 18px;
}
.navbar .dropdown-item i {
	font-size: 16px;
	min-width: 22px;
}
.navbar .nav-item.open > a {
	background: none !important;
}
.navbar .dropdown-menu {
	border-radius: 1px;
	border-color: #e5e5e5;
	box-shadow: 0 2px 8px rgba(0,0,0,.05);
}
.navbar .dropdown-menu a {
	color: #777;
	padding: 8px 20px;
	line-height: normal;
}
.navbar .dropdown-menu a:hover, .navbar .dropdown-menu a:active {
	color: #333;
}	
.navbar .dropdown-item .material-icons {
	font-size: 21px;
	line-height: 16px;
	vertical-align: middle;
	margin-top: -2px;
}
.navbar .badge {
	color: #fff;
	background: #f44336;
	font-size: 11px;
	border-radius: 20px;
	position: absolute;
	min-width: 10px;
	padding: 4px 6px 0;
	min-height: 18px;
	top: 5px;
}
.navbar a.notifications, .navbar a.messages {
	position: relative;
	margin-right: 10px;
}
.navbar a.messages {
	margin-right: 20px;
}
.navbar a.notifications .badge {
	margin-left: -8px;
}
.navbar a.messages .badge {
	margin-left: -4px;
}	
.navbar .active a, .navbar .active a:hover, .navbar .active a:focus {
	background: transparent !important;
}
@media (min-width: 1200px){
	.form-inline .input-group {
		width: 300px;
		margin-left: 30px;
	}
}
@media (max-width: 1199px){
	.form-inline {
		display: block;
		margin-bottom: 10px;
	}
	.input-group {
		width: 100%;
	}
}


.dropdown-menu {
  z-index: 2000;
  position: absolute;
  right: 0;
  top: 60px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin: 0px 20px 0px 0px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
}

.dropdown-menu:before {
  content:"";
  position: absolute;
  right: 11px;
  top: -10px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 10px 10px 10px;
  border-color: #000 transparent #ffffff transparent;
  z-index:9999;
}
.dropdown-menu:after {
  content:"";
  position: absolute;
  right: 11px;
  top: -14px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 10px 14px 10px;
  border-color: transparent transparent #ccc transparent;
  z-index:9998;
}

.dropdown-menu ul {
  list-style-type: none; /* Remove default list styles */
  margin: 0;
  padding: 0;
}

.dropdown-menu li {
  padding: 8px 16px; /* Padding around each dropdown item */
  cursor: pointer; /* Show pointer cursor on hover */
}

.dropdown-menu li:hover {
  background-color: #f0f0f0; /* Background color on hover */
}
`, "",{"version":3,"sources":["webpack://./src/css/StylesHeader.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,cAAc;IACd,sEAAsE;IACtE,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,SAAS;IACT,sEAAsE;IACtE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,2BAA2B;EAC7B;;;EAGA;IACE,sEAAsE;IACtE,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;IAC3B,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;;EAEb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,yBAAyB;IACzB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,oCAAoC;IACpC,WAAW;EACb;;EAEA;IACE,MAAM;IACN,UAAU;EACZ;;EAEA;IACE,WAAW,EAAE,+BAA+B;IAC5C,YAAY,EAAE,gCAAgC;IAC9C,yBAAyB;IACzB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,WAAW,EAAE,+BAA+B;IAC5C,YAAY,EAAE,gCAAgC;EAChD;;AAEF;IACI,YAAY;IACZ,cAAc;EAChB;;;;;AAKF;AACA;IACI,eAAe;IACf,oCAAoC;IACpC,kBAAkB;IAClB,YAAY;AAChB;AACA;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,8BAA8B;EAC9B,wBAAwB;EACxB,8CAA8C,EAAE,mBAAmB;AACrE;AACA;IACI,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,cAAc;IACd,UAAU;IACV,SAAS;IACT,YAAY;IACZ,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,WAAW;IACX,UAAU;IACV,aAAa;IACb,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,cAAc;IACd,0BAA0B;AAC9B;AACA;EACE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA,8BAA8B;AAC9B;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;;AAGA;;;;;;;;;;;;;;;;;;;;;;;GAuBG;;;AAGH;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,gCAAgC;CAChC,kCAAkC;AACnC;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,cAAc;CACd,WAAW;CACX,kBAAkB;AACnB;AACA;CACC,WAAW;CACX,eAAe;CACf,mBAAmB;CACnB,uCAAuC;AACxC;AACA;CACC,eAAe;CACf,iBAAiB;AAClB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,6BAA6B;AAC9B;AACA;CACC,eAAe;CACf,YAAY;CACZ,uBAAuB;CACvB,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV,YAAY;CACZ,YAAY;AACb;AACA;CACC,cAAc;CACd,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;CACf,eAAe;AAChB;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,qCAAqC;AACtC;AACA;CACC,WAAW;CACX,iBAAiB;CACjB,mBAAmB;AACpB;AACA;CACC,WAAW;AACZ;AACA;CACC,eAAe;CACf,iBAAiB;CACjB,sBAAsB;CACtB,gBAAgB;AACjB;AACA;CACC,WAAW;CACX,mBAAmB;CACnB,eAAe;CACf,mBAAmB;CACnB,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,QAAQ;AACT;AACA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,kCAAkC;AACnC;AACA;CACC;EACC,YAAY;EACZ,iBAAiB;CAClB;AACD;AACA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;CACA;EACC,WAAW;CACZ;AACD;;;AAGA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,wBAAwB;EACxB,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,kDAAkD;EAClD,YAAY;AACd;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,sDAAsD;EACtD,YAAY;AACd;;AAEA;EACE,qBAAqB,EAAE,+BAA+B;EACtD,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iBAAiB,EAAE,sCAAsC;EACzD,eAAe,EAAE,iCAAiC;AACpD;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;AAC3D","sourcesContent":[".header {\n    display: flex;\n    align-items: center;\n    background-color: #fbfbfb;\n    padding: 5px;\n    justify-content: space-between;\n  }\n  \n  .icon {\n    margin-right: 10px;\n  }\n  .iconprofils {\n    margin-left: auto;\n  }\n  \n  .title h1 {\n    margin: 0;\n    color: #444746;\n    font-family: Google Sans,Roboto,RobotoDraft,Helvetica,Arial,sans-serif;\n    font-size: 17px;\n    text-align: left;\n    font-variant-ligatures: no-contextual;\n    font-weight: normal;\n    padding-bottom: 2px;\n    font-weight: 500;\n    text-shadow: 0 0 black;\n  }\n  \n  .title p {\n    margin: 0;\n    font-family: Google Sans,Roboto,RobotoDraft,Helvetica,Arial,sans-serif;\n    font-size: 14px;\n    color: #444746;\n    overflow: hidden;\n    vertical-align: text-bottom;\n  }\n  \n\n  nav ul {\n    font-family: Google Sans,Roboto,RobotoDraft,Helvetica,Arial,sans-serif;\n    font-size: 14px;\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    margin-left: -6px;\n  }\n  \n  nav ul li {\n    display: inline-block;\n    position: relative;\n  }\n  \n  nav ul li a {\n    vertical-align: text-bottom;\n    display: block;\n    padding: 0px 6px;\n    text-decoration: none;\n    color: #333;\n\n  }\n  \n  nav ul li:hover > ul {\n    display: block;\n  }\n  \n  nav ul ul {\n    display: none;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    background-color: #ffffff;\n    padding: 0;\n    width: auto;\n    margin-left: 5px;\n    z-index:99999;\n  }\n  \n  nav ul ul li {\n    width: 100%;\n    min-width: 150px;\n  }\n  \n  nav ul ul li a {\n    padding: 10px 20px;\n    font-size: 12.5px;\n  }\n  \n  nav ul ul li a:hover {\n    background-color: rgb(220, 220, 220);\n    width: auto;\n  }\n\n  nav ul ul ul {\n    top: 0;\n    left: 100%;\n  }\n   \n  .box {\n    width: auto; /* 100% of the viewport width */\n    height: auto; /* 100% of the viewport height */\n    background-color: #ffffff;\n    overflow: auto;\n    border: 1px solid #e6e3e3;\n  }\n  \n  .box_icon {\n    width: 97.50vw;\n    height: 39px;\n    background-color: #eff6ff;\n    margin: 10px;\n    border-radius: 50px;\n    padding: 2px 2px 2px 6px;\n  }\n  \n  .icon_option_select {\n    display: inline-block;\n    vertical-align: middle;\n  }\n  .icon_option {\n    display: inline-block;\n    margin: 5px;\n  }\n  \n  .icon_option img {\n    width: 24px; /* Adjust the width as needed */\n    height: 24px; /* Adjust the height as needed */\n  }\n\n.material-symbols-outlined {\n    padding: 1px;\n    color: #444746;\n  font-variation-settings:\n  'FILL' 0,\n  'wght' 200,\n  'GRAD' 0,\n  'opsz' 24\n}\n.material-symbols-outlined:hover{\n    cursor: pointer;\n    background-color: rgb(226, 226, 226);\n    border-radius: 5px;\n    padding: 1px;\n}\n.container-main-view {\n  background: #f9fbfd !important;\n  border-bottom: 1px solid #f9fbfd !important;\n  margin-bottom: -1px !important;\n  padding: 10px !important;\n  box-shadow: 0 2px 4px rgba(166, 166, 166, 0.1); /* Add box shadow */\n}\n.submenu-items i {\n    color: #444746;\n    margin-right: 10px;\n}\n.flex-box{\n    width: 100% !important;\n}\n.positionfix{\n    position:fixed;\n    bottom:0px;\n    right:0px;\n    z-index:9999;\n    width: 100%;\n    background-color: #F0F0F0;\n}\n.positionfixduplicatetable{\n    position: fixed;\n    bottom: 0px;\n    right: 0px;\n    z-index: 9999;\n    width: 100%;\n    background-color: #eff6ff;\n    height: 300;\n    overflow: auto;\n    border-top: 2px solid #ccc;\n}\n.select2-dropdown{\n  z-index: 99999 !important;\n}\n\n/* Styles for the menu */\n.menu {\n  display: flex;\n  justify-content: space-between;\n  color: #444746;\n  font-size: 14px;\n  letter-spacing: .2px;\n  text-shadow: 0 0 black;\n}\n\n/* Styles for each menu category */\n.menu div {\n  margin-right: 20px;\n}\n\n.menu h2 {\n  font-size: 16px;\n  margin-bottom: 5px;\n}\n\n.menu ul {\n  list-style: none;\n  padding: 0;\n}\n\n/* Styles for each menu item */\n.menu li {\n  /* margin-bottom: 5px; */\n}\n\n.menu li a {\n  color: #333;\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n}\n\n.menu li a i {\n  margin-right: 10px;\n}\n\n.luckysheet-cell-row-0 {\n  font-weight: bold;\n}\n\n\n/* .btn, .btn-large, .btn-small, .btn-flat  {\n  line-height: 6px !important;\n  display: inline-block;\n  height: 18px !important;\n  padding: 0 2rem;\n  vertical-align: middle;\n  text-transform: uppercase;\n  border: none;\n  border-radius: 2px;\n  -webkit-tap-highlight-color: transparent;\n}\n\ninput:not([type]), input[type=text]:not(.browser-default), input[type=password]:not(.browser-default), input[type=email]:not(.browser-default), input[type=url]:not(.browser-default), input[type=time]:not(.browser-default), input[type=date]:not(.browser-default), input[type=datetime]:not(.browser-default), input[type=datetime-local]:not(.browser-default), input[type=tel]:not(.browser-default), input[type=number]:not(.browser-default), input[type=search]:not(.browser-default), textarea.materialize-textarea {\n  font-size: 1rem  !important;\n  margin: 0 0 8px 0  !important;\n  margin-left: 9px  !important;\n  margin-right: 9px  !important;\n  padding: 0;\n  transition: box-shadow .3s, border .3s;\n  border: 1px solid #615c5c  !important;\n  border-radius: 5px  !important;\n  height: 2rem !important;\n  text-align: center;\n} */\n\n\n.form-inline {\n\tdisplay: inline-block;\n}\n.navbar-header.col {\n\tpadding: 0 !important;\n}\n.navbar {\t\t\n\tbackground: #fff;\n\tpadding-left: 16px;\n\tpadding-right: 16px;\n\tborder-bottom: 1px solid #d6d6d6;\n\tbox-shadow: 0 0 4px rgba(0,0,0,.1);\n}\n.nav-link img {\n\tborder-radius: 50%;\n\twidth: 36px;\n\theight: 36px;\n\tmargin: -8px 0;\n\tfloat: left;\n\tmargin-right: 10px;\n}\n.navbar .navbar-brand {\n\tcolor: #555;\n\tpadding-left: 0;\n\tpadding-right: 50px;\n\tfont-family: 'Merienda One', sans-serif;\n}\n.navbar .navbar-brand i {\n\tfont-size: 20px;\n\tmargin-right: 5px;\n}\n.search-box {\n\tposition: relative;\n}\t\n.search-box input {\n\tbox-shadow: none;\n\tpadding-right: 35px;\n\tborder-radius: 3px !important;\n}\n.search-box .input-group-addon {\n\tmin-width: 35px;\n\tborder: none;\n\tbackground: transparent;\n\tposition: absolute;\n\tright: 0;\n\tz-index: 9;\n\tpadding: 7px;\n\theight: 100%;\n}\n.search-box i {\n\tcolor: #a0a5b1;\n\tfont-size: 19px;\n}\n.navbar .nav-item i {\n\tfont-size: 18px;\n}\n.navbar .dropdown-item i {\n\tfont-size: 16px;\n\tmin-width: 22px;\n}\n.navbar .nav-item.open > a {\n\tbackground: none !important;\n}\n.navbar .dropdown-menu {\n\tborder-radius: 1px;\n\tborder-color: #e5e5e5;\n\tbox-shadow: 0 2px 8px rgba(0,0,0,.05);\n}\n.navbar .dropdown-menu a {\n\tcolor: #777;\n\tpadding: 8px 20px;\n\tline-height: normal;\n}\n.navbar .dropdown-menu a:hover, .navbar .dropdown-menu a:active {\n\tcolor: #333;\n}\t\n.navbar .dropdown-item .material-icons {\n\tfont-size: 21px;\n\tline-height: 16px;\n\tvertical-align: middle;\n\tmargin-top: -2px;\n}\n.navbar .badge {\n\tcolor: #fff;\n\tbackground: #f44336;\n\tfont-size: 11px;\n\tborder-radius: 20px;\n\tposition: absolute;\n\tmin-width: 10px;\n\tpadding: 4px 6px 0;\n\tmin-height: 18px;\n\ttop: 5px;\n}\n.navbar a.notifications, .navbar a.messages {\n\tposition: relative;\n\tmargin-right: 10px;\n}\n.navbar a.messages {\n\tmargin-right: 20px;\n}\n.navbar a.notifications .badge {\n\tmargin-left: -8px;\n}\n.navbar a.messages .badge {\n\tmargin-left: -4px;\n}\t\n.navbar .active a, .navbar .active a:hover, .navbar .active a:focus {\n\tbackground: transparent !important;\n}\n@media (min-width: 1200px){\n\t.form-inline .input-group {\n\t\twidth: 300px;\n\t\tmargin-left: 30px;\n\t}\n}\n@media (max-width: 1199px){\n\t.form-inline {\n\t\tdisplay: block;\n\t\tmargin-bottom: 10px;\n\t}\n\t.input-group {\n\t\twidth: 100%;\n\t}\n}\n\n\n.dropdown-menu {\n  z-index: 2000;\n  position: absolute;\n  right: 0;\n  top: 60px;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  margin: 0px 20px 0px 0px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  transition: all 0.3s ease;\n}\n\n.dropdown-menu:before {\n  content:\"\";\n  position: absolute;\n  right: 11px;\n  top: -10px;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 0 10px 10px 10px;\n  border-color: #000 transparent #ffffff transparent;\n  z-index:9999;\n}\n.dropdown-menu:after {\n  content:\"\";\n  position: absolute;\n  right: 11px;\n  top: -14px;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 0 10px 14px 10px;\n  border-color: transparent transparent #ccc transparent;\n  z-index:9998;\n}\n\n.dropdown-menu ul {\n  list-style-type: none; /* Remove default list styles */\n  margin: 0;\n  padding: 0;\n}\n\n.dropdown-menu li {\n  padding: 8px 16px; /* Padding around each dropdown item */\n  cursor: pointer; /* Show pointer cursor on hover */\n}\n\n.dropdown-menu li:hover {\n  background-color: #f0f0f0; /* Background color on hover */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
